module.exports = __webpack_public_path__ + "img/c1cfffdbafdc7db7927bdbc4e8c6bbc3.png";